export default __webpack_public_path__ + "static/media/Empty_Show_Animation.ae2dc73c.gif";